import { render, staticRenderFns } from "./PageInputMasked.vue?vue&type=template&id=1b1fcdeb"
import script from "./PageInputMasked.vue?vue&type=script&lang=js"
export * from "./PageInputMasked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports